import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-6" }
const _hoisted_2 = { class: "text-base leading-6 font-medium text-black" }

import { onMounted, ref, watch } from "vue"
import GgmsButton from "@/components/GgmsButton.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import FilterList from "@/components/filters/FilterList.vue"
import AttributeList from "@/components/filters/AttributeList.vue"
import FilterRule from "@/components/filters/FilterRule.vue"
import { PlusIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"
import { useGridCollectionStore } from "@/stores/grid-collection"
import { Attribute } from "@/shared/models/attributes"
import { Filter } from "@/shared/models/filter"
import { nanoid } from "nanoid"


export default /*@__PURE__*/_defineComponent({
  __name: 'MultipleBranchesComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()
const gridCollectionStore = useGridCollectionStore()

const isEditFilter = ref(false)

function isCurrentFilterStep(currentStep: string | undefined, step: string) {
    return currentStep === step
}

function openAttributeList(branchId: string) {
    const branch = workflowStore.branches.find((branch) => branch.id === branchId)
    if (!branch) {
        return
    }
    const branchIndex = workflowStore.branches.indexOf(branch)
    workflowStore.branches[branchIndex].currentStep = "attributeList"
}

function openFiltersList(branchId: string) {
    const branch = workflowStore.branches.find((branch) => branch.id === branchId)
    if (!branch) {
        return
    }
    const branchIndex = workflowStore.branches.indexOf(branch)
    workflowStore.branches[branchIndex].currentStep = "filterList"
}
function selectAttribute(attribute: Attribute, branchId: string) {
    const branch = workflowStore.branches.find((branch) => branch.id === branchId)
    if (!branch) {
        return
    }
    const branchIndex = workflowStore.branches.indexOf(branch)
    workflowStore.branches[branchIndex].currentStep = "filterRule"
    if (!workflowStore.branches[branchIndex].selectedFilter) {
        return
    }
    workflowStore.branches[branchIndex].selectedFilter = {
        ...workflowStore.branches[branchIndex].selectedFilter,
        field: attribute.name as string,
        type: attribute.type as string,
        displayName: attribute.displayName as string,
    }

    isEditFilter.value = false
}

function clearBranchFilters(branchId?: string) {
    const branch = workflowStore.branches.find((branch) => branch.id === branchId)
    if (!branch) {
        return
    }
    const branchIndex = workflowStore.branches.indexOf(branch)
    workflowStore.branches.splice(branchIndex, 1)
    workflowStore.branches = workflowStore.branches.map((branch, index) => ({
        ...branch,
        value: `Branch ${index + 1}`,
    }))
    workflowStore.areButtonDisabled = true
}

function addFilterToGroup(filter: Filter, branchId?: string) {
    // TODO - we need to discuss about object type
    if (filter.field === "phones") {
        filter.field = "phones.number"
    } else if (filter.field === "emails") {
        filter.field = "emails.emailAddress"
    }
    const branch = workflowStore.branches.find((branch) => branch.id === branchId)
    if (!branch) {
        return
    }
    const branchIndex = workflowStore.branches.indexOf(branch)

    if (!branch?.filtersGroups?.at(branch.selectedFilterGroup!)) {
        workflowStore.branches.at(branchIndex)?.filtersGroups?.push({ filters: [filter] })
        return
    }
    if (branchIndex) {
        workflowStore.branches.at(branchIndex)?.filtersGroups?.at(branch.selectedFilterGroup!)?.filters.push(filter)
    }
}

function editFilterGroup(filter: Filter, branchId?: string) {
    if (filter.field === "phones") {
        filter.field = "phones.number"
    } else if (filter.field === "emails") {
        filter.field = "emails.emailAddress"
    }
    const branch = workflowStore.branches.find((branch) => branch.id === branchId)
    if (!branch) {
        return
    }
    const branchIndex = workflowStore.branches.indexOf(branch)
    if (!branchIndex) {
        return
    }

    workflowStore.branches[branchIndex].filtersGroups[branch.selectedFilterGroup!].filters[
        branch.selectedFilterIndex!
    ] = filter
}

function applyFilter(filter: Filter, branchId: string) {
    isEditFilter.value ? editFilterGroup(filter, branchId) : addFilterToGroup(filter, branchId)
    openFiltersList(branchId)

    workflowStore.areButtonDisabled = false
}
function cancelFilter(branchId: string) {
    resetSelectedFilter(branchId)
    openFiltersList(branchId)
}
function resetSelectedFilter(branchId: string) {
    const branch = workflowStore.branches.find((branch) => branch.id === branchId)
    if (!branch) {
        return
    }
    const branchIndex = workflowStore.branches.indexOf(branch)
    workflowStore.branches[branchIndex].selectedFilter = { field: "", type: "", displayName: "" }
}

function editFilter(filter: Filter, filterIndex: number, branchId: string) {
    isEditFilter.value = true
    const branch = workflowStore.branches.find((branch) => branch.id === branchId)
    if (!branch) {
        return
    }
    const branchIndex = workflowStore.branches.indexOf(branch)
    if (!branchIndex) {
        return
    }
    workflowStore.branches[branchIndex].selectedFilter = {
        field: filter.field,
        type: filter.type as string,
        value: filter.value as string,
        rule: filter.rule,
        displayName: filter.displayName as string,
    }
    workflowStore.branches[branchIndex].currentStep = "filterRule"
    workflowStore.branches[branchIndex].selectedFilterIndex = filterIndex
}

function addBranch() {
    workflowStore.branches.push({
        id: nanoid(),
        value: `Branch ${workflowStore.branches.length + 1}`,
        filtersGroups: [],
        currentStep: undefined,
        selectedFilterGroup: 0,
        selectedFilterIndex: 0,
        selectedFilter: {
            field: "",
            type: "",
            rule: "",
            value: "",
            displayName: "",
        },
    })
    if (workflowStore.branches[0].filtersGroups?.length) {
        workflowStore.areButtonDisabled = false
    }
}

watch(
    () => workflowStore.noneBranch?.value,
    () => (workflowStore.areButtonDisabled = false)
)

onMounted(() => {
    gridCollectionStore.getPrototypesByPage("contacts")
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workflowStore).branches, (branch, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: branch.id,
        class: "flex flex-col rounded-lg border border-gray-200 shadow-sm py-3 px-4 gap-y-3"
      }, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(branch.value), 1),
        (isCurrentFilterStep(branch.currentStep, 'attributeList'))
          ? (_openBlock(), _createBlock(AttributeList, {
              key: 0,
              class: "mt-6",
              onOnAttributeSelect: ($event: any) => (selectAttribute($event, branch.id as string))
            }, null, 8, ["onOnAttributeSelect"]))
          : _createCommentVNode("", true),
        (isCurrentFilterStep(branch.currentStep, 'filterRule'))
          ? (_openBlock(), _createBlock(FilterRule, {
              key: 1,
              class: "mt-6",
              filter: branch.selectedFilter!,
              isUpdated: isEditFilter.value,
              onApplyFilter: ($event: any) => (applyFilter($event, branch.id as string)),
              onCancel: ($event: any) => (cancelFilter(branch.id as string))
            }, null, 8, ["filter", "isUpdated", "onApplyFilter", "onCancel"]))
          : _createCommentVNode("", true),
        (isCurrentFilterStep(branch.currentStep, 'filterList'))
          ? (_openBlock(), _createBlock(FilterList, {
              key: 2,
              savedFiltersGroups: branch.filtersGroups,
              isWorkflow: true,
              branchIndex: index,
              onAddNewFilter: ($event: any) => (openAttributeList(branch.id as string)),
              onEditFilter: ($event: any) => (editFilter($event.filter, $event.filterIndex, branch.id as string)),
              onClearFilters: ($event: any) => (clearBranchFilters(branch.id))
            }, null, 8, ["savedFiltersGroups", "branchIndex", "onAddNewFilter", "onEditFilter", "onClearFilters"]))
          : _createCommentVNode("", true),
        (!branch.currentStep)
          ? (_openBlock(), _createBlock(GgmsButton, {
              key: 3,
              class: "w-fit",
              onClick: ($event: any) => (openAttributeList(branch.id as string))
            }, {
              default: _withCtx(() => [
                _cache[1] || (_cache[1] = _createTextVNode("Add filters ")),
                _createVNode(_unref(PlusIcon), { class: "ml-2 w-4 h-4" })
              ]),
              _: 2,
              __: [1]
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createVNode(GgmsButton, { onClick: addBranch }, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createTextVNode("Add Branch ")),
        _createVNode(_unref(PlusIcon), { class: "ml-2 w-4 h-4" })
      ]),
      _: 1,
      __: [2]
    }),
    _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "bg-gray-200 w-[445px] -mx-6" }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-base leading-6 font-medium text-black" }, "If none of the criteria are met, go here:", -1)),
    _createVNode(GgmsInput, {
      modelValue: _unref(workflowStore).noneBranch.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).noneBranch.value) = $event)),
      label: "Branch name",
      placeholder: "Conditions not met"
    }, null, 8, ["modelValue"])
  ]))
}
}

})